import Action from 'redux/helpers/createAction'
const name = 'keywords'

export const getKeywordSerp = Action(name + '/GET_KEYWORD_SERP_DATA', (domainId, keywordId) => ({
  domainId,
  keywordId
}))

export const getKeywordSerpSuccess = Action(
  name + '/GET_KEYWORD_SERP_DATA_SUCCESS',
  (domainId, keywordId, data) => ({
    domainId,
    keywordId,
    data
  })
)

export const getKeywordSerpFailure = Action(name + '/GET_KEYWORD_SERP_DATA_FAILURE', error => ({
  error
}))

export const getKeywordHistory = Action(
  name + '/GET_KEYWORD_HISTORY_DATA',
  (domainId, keywordId) => ({
    domainId,
    keywordId
  })
)

export const getKeywordHistorySuccess = Action(
  name + '/GET_KEYWORD_HISTORY_DATA_SUCCESS',
  (domainId, keywordId, data) => ({
    domainId,
    keywordId,
    data
  })
)

export const getKeywordHistoryFailure = Action(
  name + '/GET_KEYWORD_HISTORY_DATA_FAILURE',
  error => ({
    error
  })
)

export const changeTagsVisibility = Action(name + '/TAGS_VISIBILITY', tagsHidden => ({
  tagsHidden
}))

export const getSerpHistory = Action(name + '/GET_SERP_HISTORY_DATA', (domainId, keywordId) => ({
  domainId,
  keywordId
}))

export const getSerpHistorySuccess = Action(name + '/GET_SERP_HISTORY_DATA_SUCCESS', data => ({
  data
}))

export const getSerpHistoryFailure = Action(name + '/GET_SERP_HISTORY_DATA_FAILURE', error => ({
  error
}))

export const updateKeywords = Action(name + '/UPDATE_KEYWORD_DATA', (domainId, payload) => ({
  domainId,
  payload
}))

export const updateKeywordsSuccess = Action(name + '/UPDATE_KEYWORD_DATA_SUCCESS')

export const updateKeywordsFailure = Action(name + '/UPDATE_KEYWORD_DATA_FAILURE', error => ({
  error
}))

export const addKeyword = Action(name + '/ADD_KEYWORD_DATA', (domainId, payload) => ({
  domainId,
  payload
}))

export const addKeywordSuccess = Action(name + '/ADD_KEYWORD_DATA_SUCCESS')

export const addKeywordFailure = Action(name + '/ADD_KEYWORD_DATA_FAILURE', error => ({
  error
}))

export const deleteKeywords = Action(name + '/DELETE_KEYWORD_DATA', (domainId, payload) => ({
  domainId,
  payload
}))

export const deleteKeywordsSuccess = Action(name + '/DELETE_KEYWORD_DATA_SUCCESS')

export const deleteKeywordsFailure = Action(name + '/DELETE_KEYWORD_DATA_FAILURE', error => ({
  error
}))

export const exportDomainKeywordsExcel = Action(
  name + '/EXPORT_DOMAIN_KEYWORDS_DATA_EXCEL',
  domainId => ({
    domainId
  })
)

export const exportDomainKeywordsCSV = Action(
  name + '/EXPORT_DOMAIN_KEYWORDS_DATA_CSV',
  domainId => ({
    domainId
  })
)
